import { graphql } from '@generated/gql';

/** Resolves free-text account/client search to account IDs (search-service / OpenSearch). */
export const SEARCH_ACCOUNTS_FOR_RECON_FLAGS_GRID = graphql(`
  query searchAccountsForReconFlagsGrid($input: AccountSearchInput!) {
    searchAccounts(input: $input) {
      accounts {
        id
      }
      totalCount
    }
  }
`);

/** Grid reconciliation flags: fixed sort `firstSeenAt` DESC; filter/pagination use `FetchFlagsInputForGrid`. */
export const FETCH_FLAGS_FOR_GRID = graphql(`
  query fetchFlagsForGrid($input: FetchFlagsInputForGrid!) {
    fetchFlagsForGrid(input: $input) {
      flags {
        id
        objectId
        objectType
        type
        priority
        category
        message
        notes {
          text
          author
          authorId
          createdAt
        }
        details
        state
        createdAt
        firstSeenAt
        organization {
          id
        }
        account {
          id
          custodianAccountNumber
          user {
            id
            firstName
            lastName
            entityName
          }
        }
      }
      totalCount
    }
  }
`);

/** Org-scoped KPI aggregates for the reconciliation flags spotlight dashboard. */
export const FETCH_FLAG_KPIS = graphql(`
  query fetchFlagKPIs($organizationId: ObjectID!) {
    fetchFlagKPIs(organizationId: $organizationId) {
      totalFlags
      unresolvedOverThreeDays
      typeCounts {
        flagType
        count
      }
    }
  }
`);

export const TRANSITION_FLAG = graphql(`
  mutation transitionFlag($input: TransitionFlagInput!) {
    transitionFlag(input: $input) {
      flag {
        id
      }
    }
  }
`);

/** Bulk state transitions for grid-backed reconciliation flags. */
export const BULK_TRANSITION_FLAGS_FOR_GRID = graphql(`
  mutation bulkTransitionFlagsForGrid($input: BulkTransitionFlagsInput!) {
    bulkTransitionFlagsForGrid(input: $input) {
      succeeded {
        id
        state
      }
      failed {
        flagId
        error
      }
    }
  }
`);

export const UPDATE_FLAG_NOTES = graphql(`
  mutation updateFlagNotes($input: UpdateFlagNotesInput!) {
    updateFlagNotes(input: $input) {
      flag {
        id
        notes {
          text
          author
          authorId
          createdAt
        }
      }
    }
  }
`);

export const FETCH_FLAG_TYPES = graphql(`
  query fetchFlagTypes {
    __type(name: "FlagTypes") {
      enumValues {
        name
      }
    }
  }
`);
